import { takeLatest, put, call } from 'redux-saga/effects'
import apiCall from '../helpers/apiCall'
import { Exercise } from '../types'
import {
  FETCH_EXERCISES_FAIL,
  UpdateExerciseActionType,
  UPDATE_EXERCISE,
  UPDATE_EXERCISE_SUCCESS
} from '../redux/exercisesReducer'

function* UpdateExercisesFlow(action: UpdateExerciseActionType): Generator<any, void, any> {
  try {
    const response: Exercise = yield call(apiCall, {
      endpoint: `/tutors/lesson_plans/${action.payload.lessonPlanId}/exercises/${action.payload.exercise.id}`,
      method: 'PUT',
      params: {
        exercise: action.payload.exercise
      }
    })
    yield put(UPDATE_EXERCISE_SUCCESS({ lessonPlanId: action.payload.lessonPlanId, exercise: response }))
  } catch (error) {
    yield put(FETCH_EXERCISES_FAIL())
    console.log(error)
  }
}

export default function* UpdateExercisesSaga(): Generator<any, void, any> {
  yield takeLatest([UPDATE_EXERCISE], UpdateExercisesFlow)
}
